import React from 'react';

export default function notFound() {
  return (
    <span>Not Found</span>
  );
}
